import moment from 'moment'

type Arg = (
  | {
      // startかendどちらかの指定は必要
      start: string
      end?: string
    }
  | {
      start?: string
      end: string
    }
) & {
  connectingText?: string
  language?: string
}

const DEFAULT_FORMAT = 'YYYY年MM月DD日'
const DEFAULT_FORMAT_EN = 'MMMM DD, YYYY'
// const DEFAULT_FORMAT_EXCEPT_YEAR = "MM月DD日"
// const DEFAULT_FORMAT_EXCEPT_YEAR_EN = "MMMM DD"

/**
 * 同年の場合は年を省略した期間を生成する関数
 * リデザイン後のフォーマット i18nを取得して英語対応している
 * FYI: generateDateTermをこちらに置き換える
 * @returns string
 * ex) JP 2022年10月14日 - 12月14日
 * ex) EN October 14 ~ December 14, 2022
 */

export const generateDateTerm = ({
  start,
  end,
  connectingText = '-',
  language = 'en',
}: Arg) => {
  const lang = ['en', 'ja'].includes(language) ? language : 'en'

  const formatLocalized = lang === 'ja' ? DEFAULT_FORMAT : DEFAULT_FORMAT_EN

  // TODO: 年を入れずに期間を表示する
  const formattedTermEnglish = () => {
    // if(moment(start).isSame(end, "year")){
    //   return `${moment(start).format(formatLocalizedExceptYear)} ${connectingText} ${moment(end).format(formatLocalized)}`
    // }
    return `${moment(start).format(formatLocalized)} ${connectingText} ${moment(
      end,
    ).format(formatLocalized)}`
  }

  const formattedTerm = () => {
    // if(moment(start).isSame(end, "year")){
    //   return `${moment(start).format(formatLocalized)} ${connectingText} ${moment(end).format(formatLocalizedExceptYear)}`
    // }
    return `${moment(start).format(formatLocalized)} ${connectingText} ${moment(
      end,
    ).format(formatLocalized)}`
  }

  if (!start) return `${connectingText} ${moment(end).format(formatLocalized)}`

  if (!end) return `${moment(start).format(formatLocalized)} ${connectingText}`

  if (language === 'en') return formattedTermEnglish()
  return formattedTerm()
}
